import { Component, ComponentFactoryResolver, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
//import { ChartDataSets, ChartOptions } from 'chart.js';
import { LoginService } from '../user-login/login.service';
import { CurveService } from '../curve-service/curve.service';
import html2canvas from '../curve-plotter/img_dwnload.js';

@Component({
    selector: 'app-curve-plotter',
    templateUrl: './curve-plotter.component.html',
    styleUrls: ['./curve-plotter.component.css'],
    standalone: false
})
export class CurvePlotterComponent implements OnInit {
  uri;
  d = []
  yData = []
  title = 'The Curve';
  type='ComboChart';
  data =[];
  width;
  height;
  loading: boolean = true

  @Input() temperatures: []
  @Input() timeArray: []
  @Input() firstDerivative: []
  @Input() thermalValues: {}
  @Input() keyPoints: {}
  columnNames = [{ type: 'number',lable:"Time"}, { type: 'number',lable:"TL"},{ type: 'number',lable:"TE_Low"}, { type: 'number',lable:"TE_High"},{ type: 'number',lable: "T_Sol"}, { type: 'number',lable:"Rem"}, { type: 'number',lable:"First Derivative"},{ type: 'number',lable: " "},
//{"type": "string"}
  ]
                     /*        colors: [ "#ffff00", "#ffa500","#34ebeb", "#0d64e6", "#98f013", "#e75480", "black"],           */
  options = {
    colors: [ "#ffff00", "#ffa500","#34ebeb", "#0d64e6", "#98f013", "#e75480", "black"],
    areaOpacity: 0.5,
    displayAnnotations: true,   

    hAxis: {
      title: 'Time(Seconds)',
      
    },
    vAxes:{
      0:{ title: 'Temp (°Celsius)' },
      1:{ title: 'First Derivatives'},
      
      },
    crosshair:{
      color:'black',
      trigger:'both'
    },
    animation:{
      duration: 5000,
      easing: 'out',
      startup: true
    },
    series: {
      0: {
        type: 'area',
        targetAxisIndex: 0
      },
      1:{
        type: 'area',
        targetAxisIndex: 0
      },
      2: {
        type: 'area',
        targetAxisIndex: 0
      },
      3: {
        type: 'area',
        targetAxisIndex: 0
      },
      4: {
        type: 'area',
        targetAxisIndex: 0
      },
      5: {
        type: 'line',
        targetAxisIndex: 1,
      },
      6: {
        type: 'line',
        targetAxisIndex: 0
      }
    },
    legend: 'none',
	  dataLabels: {
        enabled: true,
        enabledOnSeries: [1]
      },
  }
  role: string;
  serverErrorMessages: string;

  constructor(private curveService: CurveService, private loginService: LoginService, private router: Router) { }

  ngOnInit() {
    
    if (this.loginService.shouldBlock()) {
      alert('Low Balance! Redirecting...');
      this.router.navigateByUrl('/home');
    }
   //console.log('in init curve plotter')
    this.uri="";
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
        }
      )
    }
    else{
      alert('PLEASE LOGIN');
      this.router.navigateByUrl('/signin');
    }
    this.width = 850;
    this.height = 400;

  console.log('got data points', this.keyPoints)
    for(var i=0; i< Math.min(this.temperatures.length, this.timeArray.length, this.firstDerivative.length); i++){
      // var tempData = [this.timeArray[i], this.temperatures[i], this.firstDerivative[i]]
      var tempData = [];
      if(i<=this.keyPoints['TL']){
        tempData=[this.timeArray[i], this.temperatures[i],null,null,null,null, this.firstDerivative[i], this.temperatures[i]]
      }
      else if(i>this.keyPoints['TL'] && i<=this.keyPoints['TE_Low']){
        tempData=[this.timeArray[i],null, this.temperatures[i],null,null,null, this.firstDerivative[i], this.temperatures[i]]
      }
      else if(i>this.keyPoints['TE_Low'] && i<=this.keyPoints['TE_High']){
        tempData=[this.timeArray[i],null,null, this.temperatures[i],null,null, this.firstDerivative[i], this.temperatures[i]]
      }
      else if(i>this.keyPoints['TE_High'] && i<=this.keyPoints['T_Sol']){
        tempData=[this.timeArray[i],null,null,null, this.temperatures[i],null, this.firstDerivative[i], this.temperatures[i]]
      }
      else if(i>this.keyPoints['T_Sol']){
       // tempData=[this.timeArray[i],null,null,null,null, this.temperatures[i], this.firstDerivative[i], this.temperatures[i]]
        let temp_deff=this.temperatures[i+5]-this.temperatures[i+4];
			console.log("temp_deff");
			if(temp_deff < -5){
				break;
			}else{
        tempData=[this.timeArray[i],null,null,null,null, this.temperatures[i], this.firstDerivative[i], this.temperatures[i]]
      }
      
    }

      
     console.log("TL ="+this.keyPoints['TL']+" TE_LOW ="+this.keyPoints['TE_Low']+" TE_HIGH ="+this.keyPoints['TE_High']+" T_SOL ="+this.keyPoints['T_Sol'])
    this.data.push(tempData)
    // console.log(this.data);
    }

    console.log(this.data);
    
    this.loading = false;
  }

  public chartReady(chart) {
    
    this.uri= chart.wrapper.getChart().getImageURI();
    // console.log(this.uri);
 }

 public onError(event)
 {
  if(this.role == "TECHEXPERT")
  {
    alert("The graph cannot be generated because there is an error in the temperatures data, or first derivatives data. The sample needs to be retaken.");
  }
  else
  {
    alert("The graph cannot be generated because there is an error in the temperatures data, or first derivatives data. The sample needs to be retaken.");
    //this.router.navigateByUrl('/view-all-graphs');
  }
 }

  downloadCanvas(event) {

html2canvas(document.getElementById("wrapper"),

{
  allowTaint: true,
  useCORS: true
       
}).then(function (canvas) {

  var anchorTag = document.createElement("a");
  anchorTag.download = "CURVE-DATA.png";
  anchorTag.href = canvas.toDataURL();
  anchorTag.target = '_blank';
  anchorTag.click();
});
    

    var anchor = event.target;
    anchor.href = this.uri;
   anchor.download = 'CURVE.png'
  }
  // resetWindowSize(event){
  //   //Reset the width and height based on current window size
  //   this.width = event.target.innerWidth;
  //   this.height = event.target.innerHeight;
  // }
}
